

















import Vue from "vue";

export default Vue.extend({
  props: {
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: false
    }
  },
  computed: {
    style() {
      return {
        top: `${this.y}px`,
        left: `${this.x}px`,
        color: this.color || "white"
      };
    }
  }
});
